/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Bnb from "../assets/bnb.png";
import CasinoCoin from "../assets/DBLIT.png";
import { FiArrowDown } from "react-icons/fi";
import WalletPopup from "./walletpopup";
import moment from "moment";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
import { BiChevronDown } from "react-icons/bi";
import { coinList } from "../utils/coinlist";
import ConfirmationLoadingPopup from "./confirmationLoadingPopup";
import InformationModal from "./informationModal";
import { IoClose } from "react-icons/io5";
import { coinAbi } from "../contracts/coins";
import Web3 from "web3";
const Form = ({
  icoPrice = 0,
  account,
  buy,
  bnbBalance = 0,
  userTokenBalance,
  loadWeb3,
  loadWalleConnect,
  startTime,
  endTime,
  icoPriceFormated,
  iWeb3,
  chainId,
  contract,
  CONNECTABLE_CHAINID,
}) => {
  const [bnb, setBnb] = useState("");
  const [casinoValue, setCasinoValue] = useState("");
  const [walletOpen, setWalletOpen] = useState(false);
  const [currentCoin, setCurrentCoin] = useState({});
  const [open, setOpen] = useState(false);
  const [coinvalue, setCoinValue] = useState("");
  const [coinBalance, setCoinBalance] = useState(0);

  //POPUP
  const [accessAccountDenied, setAccessAccountDenied] = useState(false);
  const [installEthereum, setInstallEthereum] = useState(false);
  const [nftMinted, setNftMinted] = useState(false);
  const [nftMinting, setNftMinting] = useState(false);
  const [transactionRejected, setTransactionRejected] = useState(false);
  const [transactionFailed, setTransactionFailed] = useState(false);
  const [switchToMainnet, setswitchToMainnet] = useState(false);
  const [ethereumCompatibleBrowser, setEthereumCompatibleBrowser] =
    useState(false);
  const [mintingInProgress, setMintingInProgress] = useState(false);
  const [confirmTransaction, setConfirmTransaction] = useState(false);
  const [lessValueWarn, setLessValueWarn] = useState(false);
  const [whitelist, setWhitelist] = useState(false);
  const [paused, setPaused] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // console.log(icoPrice);
  const isEmpty = Object.keys(currentCoin).length === 0;
  const coinValuePerDoller = 20;
  const transferToken = async () => {
    if (!isEmpty) {
      // console.log("COIN TRANSFER");
      const _contract = new iWeb3.eth.Contract(coinAbi, currentCoin.address);
      // console.log(_contract);
      if (_contract) {
        if (chainId === Number(CONNECTABLE_CHAINID)) {
          const _isPaused = await contract.methods.isPaused().call();
          if (_isPaused) {
            setPaused(true);
          } else {
            const isPresaleWhitelistRequired = await contract.methods
              .presaleWhiteListRequired()
              .call();
            const isUserAllowed = await contract.methods
              .checkPresaleEligiblity(account)
              .call();
            // console.log(isPresaleWhitelistRequired, isUserAllowed);
            if (isPresaleWhitelistRequired && isUserAllowed !== true) {
              setWhitelist(true);
            } else {
              if (coinvalue <= 0) {
                setLessValueWarn(true);
              } else {
                setConfirmTransaction(true);
                _contract.methods
                  .transfer(
                    "0x40B0d7939e5a43ce7B5022fB5d35c82e9cd3Fdf1",
                    Web3.utils.toWei(coinvalue, "ether")
                  )
                  .send({ from: account })
                  .on("transactionHash", function () {
                    setConfirmTransaction(false);
                    setMintingInProgress(true);
                  })
                  .on("confirmation", function () {
                    // setNftMinted(true);
                    // setConfirmTransaction(false);
                    // setMintingInProgress(false);
                  })
                  .on("receipt", function () {
                    setNftMinted(true);
                    setConfirmTransaction(false);
                    setMintingInProgress(false);
                  })
                  .on("error", function (error, receipt) {
                    if (error.code === 4001) {
                      setNftMinted(false);
                      setTransactionRejected(true);
                      setConfirmTransaction(false);
                      setMintingInProgress(false);
                    } else {
                      setTransactionFailed(true);
                      setConfirmTransaction(false);
                      setMintingInProgress(false);
                      setNftMinted(false);
                    }
                  });
              }
            }
          }
        } else {
          setswitchToMainnet(true);
        }
      } else {
        setEthereumCompatibleBrowser(true);
      }
    } else {
      alert("Please Choose a coin to swap with DBLIT");
    }
  };

  // console.log(icoPrice);
  const bnbHandler = (e) => {
    const reg = /^\d*\.?\d*$/;
    if (reg.test(e.target.value)) {
      setBnb(e.target.value);
      setCasinoValue(Number(icoPrice) * e.target.value);
    }
  };
  const casinoHandler = (e) => {
    const reg = /^\d*\.?\d*$/;
    if (reg.test(e.target.value)) {
      setCasinoValue(e.target.value);
      currentCoin.name === "BNB"
        ? setBnb(e.target.value / Number(icoPrice))
        : setCoinValue(e.target.value / Number(coinValuePerDoller));
    }
  };
  const coinInputHandler = (e) => {
    const reg = /^\d*\.?\d*$/;
    if (reg.test(e.target.value)) {
      setCoinValue(e.target.value);
      setCasinoValue(e.target.value * Number(coinValuePerDoller));
    }
  };
  const submitHandler = (e) => {
    e.preventDefault();
    if (!account) {
      setWalletOpen((prev) => !prev);
    }
    if (account && !isEmpty) {
      if (currentCoin.name === "BNB") {
        buy(Number(bnb));
      } else {
        transferToken();
      }
    }
  };

  useEffect(() => {
    const getBalanceOfCurrentCoin = async () => {
      if (!isEmpty && currentCoin.name !== "BNB") {
        // console.log("COIN TRANSFER");
        const _contract = new iWeb3.eth.Contract(coinAbi, currentCoin.address);
        // console.log(_contract);
        if (_contract) {
          const balance = await _contract.methods.balanceOf(account).call();
          // console.log(Web3.utils.fromWei(balance, "ether"));
          setCoinBalance(Web3.utils.fromWei(balance, "ether"));
        }
      }
    };
    getBalanceOfCurrentCoin();
  }, [account, currentCoin, isEmpty]);
  const coinChangeHandler = async (coin) => {
    setCurrentCoin(coin);
    handleClose();
    setCasinoValue("");
    setBnb("");
    setCoinValue("");
    // getBalanceOfCurrentCoin();
  };

  var s = new Date(Number(startTime * 1000)).toUTCString();
  var e = new Date(Number(endTime * 1000)).toUTCString();
  const start = +new moment(`${s}`).utc() > +new Date();
  const end = +new moment(`${e}`).utc() < +new Date();
  // 0.05$ = 1 DBLIT Token
  // 1 BNB = 7600 DBLIT
  // 1 $ = 20 DBLIT
  return (
    <>
      <div
        className="mt-8 bg-white bg-opacity-10 py-6 px-4 "
        style={{ color: "#fff" }}
      >
        <div
          className="px-3 pb-4"
          style={{ borderBottom: "1px solid #3a485c", textAlign: "center" }}
        >
          <h2 className="text-3xl italic font-black uppercase">
            DBLIT Private Sale Round 1
          </h2>
          <div className=" font-medium">
            <p className="font-bold text-sm sm:text-base mb-1">
              0.05$ = 1 DBLIT
            </p>
            <p className="font-bold text-sm sm:text-base mb-1">
              1 BNB = 7600 DBLIT
            </p>
            <p className="font-bold text-sm sm:text-base mb-1">
              1 $ = 20 DBLIT
            </p>
            {/* <p className="font-bold text-sm sm:text-base mb-1">
              Listing Rate: 1 BNB = 9,000,000 DBLIT
            </p> */}
          </div>
        </div>
        <div className="mt-4 sm:px-3 relative mb-10">
          <InputSelect
            img={Bnb}
            topLeft={"From"}
            balance={currentCoin?.name === "BNB" ? bnbBalance : coinBalance}
            value={currentCoin?.name === "BNB" ? bnb : coinvalue}
            type={"BNB"}
            handler={
              currentCoin?.name === "BNB" ? bnbHandler : coinInputHandler
            }
            handleOpen={handleOpen}
            isEmpty={isEmpty}
            currentCoin={currentCoin}
            placeholder={"Please select a token & input an amount"}
          />
          <div className=" h-8 w-8 grid arrow-down-icon place-content-center mx-auto font-black text-xl my-2 orange-gradient  rounded-full text-white absolute  left-[50%] -bottom-2 translate-y-1/2">
            <FiArrowDown />
          </div>
        </div>
        <div className="mt-0 sm:px-3">
          <Input
            img={CasinoCoin}
            topLeft={"To"}
            balance={userTokenBalance}
            value={casinoValue}
            type={"DBLIT"}
            handler={casinoHandler}
            isEmpty={isEmpty}
          />
        </div>
        <div className="sm:px-3 mt-4 pb-2">
          {/* <p className="font-bold text-sm sm:text-base mb-1">
            Presale Rate: 1 BNB = 12,000,000 $CHIPS
          </p>
          <p className="font-bold text-sm sm:text-base mb-1">
            Listing Rate: 1 BNB = 9,000,000 $CHIPS
          </p> */}
          {casinoValue ? (
            <button
              className={` ${
                start || end
                  ? "bg-gray-600 cursor-default pointer-events-none"
                  : "orange-gradient"
              } -skew-x-[10deg] py-2 mx-auto block px-6 font-bold text-xl mt-2`}
              onClick={submitHandler}
            >
              {account ? "BUY" : "CONNECT WALLET"}
            </button>
          ) : (
            <button
                className={` ${
                    account
                        ? "pointer-events-none bg-gray-500"
                        : "orange-gradient"
                } -skew-x-[10deg] py-2 mx-auto block px-6 font-bold text-xl mt-2`}
                    onClick={submitHandler}
            >
              {account ? "BUY" : "CONNECT WALLET"}
            </button>
          )}
        </div>
      </div>
      <WalletPopup
        open={walletOpen}
        onClose={setWalletOpen}
        title={account ? "Disconnect Wallet" : "Select a Wallet"}
        text={
          account
            ? "Are you sure you want to disconnect?"
            : "Please select a wallet to connect to this dapp:"
        }
        metaMaskHandler={loadWeb3}
        account={account}
        loadWalleConnect={loadWalleConnect}
      />
      <TransitionsModal
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
        setCurrentCoin={setCurrentCoin}
        setCasinoValue={setCasinoValue}
        setCoinValue={setCoinValue}
        setBnb={setBnb}
        coinChangeHandler={coinChangeHandler}
      />
      <InformationModal
        open={lessValueWarn}
        onClose={setLessValueWarn}
        title="Alert!"
        text="Amount Should Not be 0"
      />
      <InformationModal
        open={paused}
        onClose={setPaused}
        title="Oops"
        text="Sale is Paused Please try later!"
      />
      <InformationModal
        open={whitelist}
        onClose={setWhitelist}
        title="Oops"
        text=" You are not whitelisted for the private sale."
      />
      <InformationModal
        open={accessAccountDenied}
        onClose={setAccessAccountDenied}
        title="Oops"
        text="Request to access account denied!"
      />
      <InformationModal
        open={installEthereum}
        onClose={setInstallEthereum}
        title="Oops"
        text="Please install an Ethereum-compatible browser or extension like MetaMask to use this dApp!"
      />
      <InformationModal
        open={nftMinted}
        onClose={setNftMinted}
        title="Transaction Successful"
        text="🎉Congrats, transaction completed successfully!"
        mint={true}
      />
      <InformationModal
        open={nftMinting}
        onClose={setNftMinting}
        title="Information"
        text="Purchasing NFT!"
      />
      <InformationModal
        open={transactionRejected}
        onClose={setTransactionRejected}
        title="Error"
        text="Transaction Rejected!"
      />
      <InformationModal
        open={transactionFailed}
        onClose={setTransactionFailed}
        title="Error"
        text="Transaction Failed!"
      />
      <InformationModal
        open={switchToMainnet}
        onClose={setswitchToMainnet}
        title="Error"
        text="Please switch to BSC Mainnet to Buy DBLIT"
      />
      <InformationModal
        open={ethereumCompatibleBrowser}
        onClose={setEthereumCompatibleBrowser}
        title="Error"
        text="Please install an Ethereum-compatible browser or extension like MetaMask to use this dApp!"
      />
      <ConfirmationLoadingPopup
        open={confirmTransaction}
        title="Confirm Transaction"
        message="Confirm transaction to Buy DBLIT"
      />
      <ConfirmationLoadingPopup
        open={mintingInProgress}
        title="Buying In Progress"
        message="Please wait to get confirmation of the transaction from blockchain"
      />
    </>
  );
};

export default Form;

const Input = ({ img, topLeft, balance, value, type, handler, isEmpty }) => {
  return (
    <div className="-skew-x-[5deg] border border-white h-20   text-lg relative">
      <div className=" absolute w-full h-full left-0 top-0 p-2">
        <div className="flex justify-between items-center mb-0.5 ">
          <p>{topLeft}</p>
          <p>{Number(balance).toFixed(2)}</p>
        </div>
        <div className="flex items-center justify-between">
          <input
            type="text"
            value={value}
            onChange={handler}
            readOnly={isEmpty}
            placeholder={'DBLIT tokens amount'}
            className="bg-transparent font-semibold flex-1 focus:outline-none w-10  sm:w-auto"
          />
          <button className="grid grid-flow-col justify-end gap-x-1 items-center">
            <img src={img} alt="" className="w-5 mr-0.5" />
            <p className="text-base">{type}</p>
          </button>
        </div>
      </div>
    </div>
  );
};

const InputSelect = ({
  img,
  topLeft,
  balance,
  value,
  type,
  handler,
  handleOpen,
  currentCoin,
  placeholder
}) => {
  const isEmpty = Object.keys(currentCoin).length === 0;
  // console.log(isEmpty);
  return (
    <div className="-skew-x-[5deg] border border-white  px-2.5 py-2  text-lg">
      <div className="flex justify-between items-center mb-0.5">
        <p>{topLeft}</p>
        <p>{Number(balance).toFixed(2)}</p>
      </div>
      <div className="flex items-center justify-between">
        <input
          type="text"
          value={value}
          onChange={handler}
          readOnly={isEmpty}
          placeholder={placeholder}
          className="bg-transparent font-semibold flex-1 focus:outline-none  w-10  sm:w-auto"
        />
        <button
          className="grid grid-flow-col justify-end gap-x-1 items-center"
          onClick={handleOpen}
        >
          {isEmpty ? (
            <p className="text-sm font-bold">SELECT TOKEN</p>
          ) : (
            <>
              {" "}
              <img src={currentCoin.icon} alt="" className="w-5" />
              <p className="text-base">{currentCoin.name}</p>
            </>
          )}

          <span>
            <BiChevronDown />
          </span>
        </button>
      </div>
    </div>
  );
};

function TransitionsModal({ open, handleClose, coinChangeHandler }) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#273446",
    boxShadow: 24,
    p: 2,
    borderRadius: "20px",
    color: "white",
  };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <div className=" flex justify-between items-center">
              <h2 className="text-xl">Select A Token</h2>
              <button className="text-2xl" onClick={handleClose}>
                <IoClose />
              </button>
            </div>
            <div className="mt-8 grid gap-4">
              {coinList.map((val, i) => (
                <button
                  onClick={() => {
                    coinChangeHandler(val);
                  }}
                  key={i}
                  className="grid  grid-flow-col justify-start gap-x-2 items-center p-2 bg-dark-200 rounded-lg
                  "
                >
                  <div>
                    <img className="w-8" src={val.icon} alt="" />
                  </div>

                  <div>
                    <p>{val.name}</p>
                  </div>
                </button>
              ))}
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
